import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { DepartmentCard } from './components/Card/DepartmentCard';
import { getDepartmentPagedOptions } from './model/DepartmentQuery';

export function DepartmentBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { pagination, useTotalElements, ...paginationProps } = usePagination();
  const { search, searchProps } = useSearch();
  const { data } = useSuspenseQuery(getDepartmentPagedOptions({ ...pagination, sortDirection, search }));
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('departments.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('departments.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('departments.sortedByName')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={department => (
        <DepartmentCard
          key={department.id}
          department={department}
          to={`${department.id}`}
        />
      )}
    />
  );
}
